import React from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import ActiveWhatsappBlockInputs from './components/FormInputs';
import SimpleHeader from 'components/Headers/SimpleHeader';

function CreateActiveWhatsappBlockList() {
  return (
    <>
      <SimpleHeader
        returnPath="/admin/chat/active-whatsapp-block-list"
        showBackArrow="yes"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between">
                    <h3 className="mb-0">
                      Adicionar um novo número a ser bloqueado
                    </h3>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  <ActiveWhatsappBlockInputs />
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default CreateActiveWhatsappBlockList;
